
import React, { useMemo, useState } from 'react';
import { Link } from 'react-navi';
import { NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function Tvasahi() {
    return (
        <div>
            <Helmet>
                <meta
                    content={`8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭りに候補者が参加しました | ${
                        process.env.REACT_APP_WEBSITE_NAME
                        }`}
                    property="og:title"
                />
                <meta content={`${process.env.REACT_APP_URL}/images/news/2019-08-07-tvasahi.jpg`} property="og:image" />
                <meta content={`${process.env.REACT_APP_URL}/news/2019-08-07-tvasahi`} property="og:url" />
            </Helmet>
            <div className="hero">
                <div className="hero-head">
                    <NavBar logoImageSrc="/images/logo_black.svg" />
                </div>
            </div>
            <section className="section is-padding-bottom-0">
                <div className="container">
                    <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <Link className="has-text-primary" href="/top">
                                    TOP
                                </Link>
                            </li>
                            <li className="is-active">
                                <Link href={`/news/2019-08-07-tvasahi`} aria-current="page">
                                    8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭り
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </section>
            <section className="section">
                <div className="container is-slim">
                    <div className="content">
                        <h3>8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭りにミスサークル候補者が参加しました</h3>
                        <br />
                        <p>
                            <img src="/images/news/2019-08-07-tvasahi.jpg" />
                        </p>
                        <p>
                            <b>ミスサークル参加者によるスペシャルファッションショーを披露！</b>
                        </p>
                        <p>
                            8/7（水）に開催された「MISS/MR COLLECTION 2019 in テレ朝夏祭り」にて、「MISS CIRCLE CONTEST 2019」出場者がファッションショー形式のお披露目イベントに参加しました。
                            <br />
                            <br />
                            初となるイベント参加に出場者の皆様も、少し緊張した様子でしたが、いざ本番が始まると堂々としたランウェイ姿を披露していました。
                            <br />
                            <br />
                            観客の皆様、出場者の皆様ご参加ありがとうございました！
                            <br />
                            <br />
                        </p>
                        <p>
                            <b>現在「MISS CIRCLE CONTEST 2019」は3次審査を開催中！</b>
                        </p>
                        <p>
                            イベントの出場者は、下記の日程で3次審査に参加中です。 投票や動画配信など、ぜひ審査にご参加ください！
                            <br />
                        </p>
                        <ul>
                            <li>WEB審査 8月3日12:00〜8/20日21:59</li>
                            <li>SHOWROOM審査 8月3日12:00〜8月12日21:59</li>
                            <li>Mysta審査 8月13日20:00〜8/20日21:59</li>
                        </ul>
                        <br />
                        <p className="has-text-centered">
                            <Link className="button is-large is-primary has-text-weight-bold" href="/second">
                                3次審査 候補者をチェック！
                            </Link>
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Tvasahi;
